import * as React from 'react';

export const Trash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 19 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M3 4.2h14.4M15.8 4.2v11.2a1.6 1.6 0 0 1-1.6 1.6h-8a1.6 1.6 0 0 1-1.6-1.6V4.2m2.4 0V2.6A1.6 1.6 0 0 1 8.6 1h3.2a1.6 1.6 0 0 1 1.6 1.6v1.6M8.6 8.2V13M11.8 8.2V13" />
      </g>
    </g>
  </svg>
);
